import { Card, CardContent, CardHeader } from '@brent/core-ui/ui'
import { Skeleton } from '@brent/core-ui/ui'

export const SuggestionCardSkeleton = () => {
  return (
    <Card>
      <CardHeader className="pb-3">
        <div className="flex items-start justify-between">
          <div className="space-y-2 flex-1 min-w-0">
            {/* Title skeleton */}
            <Skeleton className="h-6 w-3/4" />
            {/* Composer skeleton */}
            <Skeleton className="h-4 w-1/2" />
          </div>
          {/* Action button skeleton */}
          <Skeleton className="h-11 w-11 rounded-md" />
        </div>
      </CardHeader>
      <CardContent>
        {/* Date skeleton */}
        <Skeleton className="h-3 w-40" />
      </CardContent>
    </Card>
  )
}
